import { action } from '../tools/reduxTools';
import { SET_COLOR_USER } from './actionTypes/avatarTypes';

export const setUserColor = (id: string) => action(async(dispatch) => {
    await dispatch({ type: SET_COLOR_USER, data: {id}});
});